<template>
  <div :class="type" class="banner">
    <div class="title" :class="{ 'title-hk': locale === 'hk' || locale === 'tw' }">
      <img v-if="type === 'pc'" :src="require(`@/assets/imgs/title/${locale}.png`)" alt="title">
      <img v-else :src="require(`@/assets/imgs/m/title/${locale}.png`)" alt="title">
    </div>
    <div class="banner-bg"></div>
    <div class="banner-line">
    </div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const type = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
